// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import topupI from "../assets/icons/topup.svg";
import cardsI from "../assets/icons/upgrade.svg";
import { HiOutlineDotsHorizontal } from 'react-icons/hi';
import { AiOutlineDollar } from "react-icons/ai";

const YourBalance = ({ showTopUp }: {showTopUp?: () => void}) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-4">$ 1,325.00</p>
      <div className="flex items-center gap-2">
        <div onClick={() => showTopUp && showTopUp()} className="w-[114px] h-[65px] cursor-pointer bg-gradient-to-b from-[#8C84FF] to-[#6158E0] rounded-xl flex items-center justify-center">
          <div className="text-center">
            <img className="inline-block" src={topupI} alt="topup" />
            <p className="text-white opacity-70 text-xs tracking-tight">Top up</p>
          </div>
        </div>
        <div className="w-[114px] h-[65px] bg-white rounded-xl flex items-center justify-center">
          <div className="text-center">
            <img className="inline-block" src={cardsI} alt="topup" />
            <p className="text-[#9392A2] opacity-70 text-xs tracking-tight mt-1">Upgrade plan</p>
          </div>
        </div>
        <div className="w-[114px] h-[65px] bg-white rounded-xl flex items-center justify-center">
          <div className="text-center">
            <HiOutlineDotsHorizontal className="w-full mt-1" />
            <p className="text-[#9392A2] opacity-70 text-xs tracking-tight mt-1.5">Other</p>
          </div>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-5 mb-2">How much you want to top up?</p>
      <div className="flex items-center gap-2">
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 20</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 50</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 100</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 200</p>
          </div>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-5 mb-1">Why do you need it?</p>
      <div className="w-[358px] text-[#0F0C18] text-sm font-mediu leading-[21px] tracking-tight">A "credit system" in an app can work in different ways. In some apps, you can load money (credits) into a digital wallet, using these credits for in-app purchases or transactions.</div>
    </>
  );
};

export default YourBalance;